/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { useWindowSize } from '@/hooks/window.hook';
import { Outlet } from 'react-router-dom';
import { RectSize } from '@/types/common';

export function MasterLayout() {
  const windowSize = useWindowSize();

  return (
    <div aria-label='master-layout' css={rootStyles(windowSize)}>
      <Outlet />
    </div>
  );
}

const rootStyles = (windowSize: RectSize) => css`
  --wd-width: ${windowSize.width / 10}rem;
  --wd-height: ${windowSize.height / 10}rem;
  --wd-w-px: ${windowSize.width / 10}rem;
  --wd-h-px: ${windowSize.height / 10}rem;
  --wd-ratio: ${windowSize.width / windowSize.height};
  width: 100%;
  min-height: var(--wd-h-px);
`;
